export const BASE_URL = "/";
